import type React from "react";
import style from "./Instruction.module.scss";

export const Instruction = ({
	instruction,
	Icon,
}: {
	instruction: string;
	Icon?: React.ReactNode;
}) => {
	return (
		<div className={style.instruction}>
			{Icon && Icon}
			<p>{instruction}</p>
		</div>
	);
};
